import { FileDeleteInput } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteFileMutationDocument } from "./file.gql";

export interface UseDeleteFileProps {
  ownerId: string;
  ownerType: string;
  onCompleted?: () => void;
  onError?: (e: Error) => void;
}

export const useDeleteFile = ({ ownerId, ownerType, onCompleted, onError }: UseDeleteFileProps) => {
  const queryClient = useQueryClient();

  const { mutate: deleteFile } = useMutation({
    mutationFn: async (input: FileDeleteInput) => {
      const client = createOperationClient("deleteFile");
      return await client.request(deleteFileMutationDocument, { input });
    },
    onSuccess: () => {
      // Invalidate file queries
      queryClient.invalidateQueries({
        queryKey: queryKeys.files.list(ownerId, ownerType),
      });

      if (onCompleted) {
        onCompleted();
      }
    },
    onError: (error) => {
      if (onError) {
        onError(error);
      }
    },
  });

  return {
    deleteFile,
  };
};
